$(document).ready(function(){
  $('ul.desktop-menu li.mega-menu').hover(
    function() {
      // Mouse over: add active class
      $(this).addClass('mega-menu-active');
    },
    function() {
      // Mouse out: remove active class
      $(this).removeClass('mega-menu-active');
    }
  );

$('.mobilesub-menu > a').click(function(event) {
   event.preventDefault()
    var $parent = $(this).parent('.mobilesub-menu');
    var $subMenu = $(this).next('.mobilemega__menu');

    // Check if the clicked submenu is already active
    if ($parent.hasClass('active')) {
        // Remove the active class and smoothly slide up the submenu
        $parent.removeClass('active');
        $subMenu.stop().slideUp(400); // Smooth slide up
    } else {
        // Remove active class from all submenus and smoothly hide others
        $('.mobilesub-menu').removeClass('active');
        $('.mobilemega__menu').stop().slideUp(400); // Smooth slide up

        // Add active class to the clicked submenu and smoothly slide it down
        $parent.addClass('active');
        $subMenu.stop().slideDown(400); // Smooth slide down
    }
});


});